import { createStructuredSelector } from 'reselect'

import {
  ACQUISITION_LIST,
  ACQUISITION_LIST_SUCCESS,
  ACQUISITION_LIST_ERROR,
  ACQUISITION_SEARCH_ARTICLE_TYPE_LIST,
  ACQUISITION_SEARCH_ARTICLE_TYPE_LIST_SUCCESS,
  ACQUISITION_SEARCH_ARTICLE_TYPE_LIST_ERROR,
  ACQUISITION_SEARCH_SET,
  ACQUISITION_PAGE_SET,
  ACQUISITION_VIEW_MODAL_SET,
  ACQUISITION_VIEW_TAB_SET,
  ACQUISITION_SEARCH_CHANGE,
  ACQUISITION_HEADER,
  ACQUISITION_SEARCH_PROJECT_LIST,
  ACQUISITION_SEARCH_PROJECT_LIST_SUCCESS,
  ACQUISITION_SEARCH_PROJECT_LIST_ERROR,
  ACQUISITION_SEARCH_ACQUISITION_TYPE_LIST,
  ACQUISITION_SEARCH_ACQUISITION_TYPE_LIST_SUCCESS,
  ACQUISITION_SEARCH_ACQUISITION_TYPE_LIST_ERROR,
  ACQUISITION_DETAIL,
  ACQUISITION_DETAIL_SUCCESS,
  ACQUISITION_DETAIL_ERROR,
  ACQUISITION_SEARCH_DEMAND_LIST,
  ACQUISITION_SEARCH_DEMAND_LIST_SUCCESS,
  ACQUISITION_SEARCH_DEMAND_LIST_ERROR,
} from '../actions';

export const NAME = 'acquisition';

export const AcquisitionList = (page, num_page, orderBy, filters, stateFilter) => ({
  type: ACQUISITION_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const AcquisitionListSuccess = (data) => ({
  type: ACQUISITION_LIST_SUCCESS,
  payload: data
});

export const AcquisitionListError = (error) => ({
  type: ACQUISITION_LIST_ERROR,
  payload: error
});

export const AcquisitionSearchArticleTypeList = () => ({
  type: ACQUISITION_SEARCH_ARTICLE_TYPE_LIST
});

export const AcquisitionSearchArticleTypeListSuccess = (data) => ({
  type: ACQUISITION_SEARCH_ARTICLE_TYPE_LIST_SUCCESS,
  payload: data
});

export const AcquisitionSearchArticleTypeListError = (error) => ({
  type: ACQUISITION_SEARCH_ARTICLE_TYPE_LIST_ERROR,
  payload: error
});

export const AcquisitionSearchSet = (data) => ({
  type: ACQUISITION_SEARCH_SET,
  payload: data
});

export const AcquisitionPageSet = (data) => ({
  type: ACQUISITION_PAGE_SET,
  payload: data
});

export const AcquisitionViewModalSet = (data) => ({
  type: ACQUISITION_VIEW_MODAL_SET,
  payload: data
});


export const AcquisitionHeader = (data) => ({
  type: ACQUISITION_HEADER,
  payload: data
});

export const AcquisitionViewTabSet = (data) => ({
  type: ACQUISITION_VIEW_TAB_SET,
  payload: data
});


export const AcquisitionSearchChangeSet = (data) => ({
  type: ACQUISITION_SEARCH_CHANGE,
  payload: data
});

export const AcquisitionSearchProjectList = () => ({
  type: ACQUISITION_SEARCH_PROJECT_LIST
});

export const AcquisitionSearchProjectListSuccess = (message) => ({
  type: ACQUISITION_SEARCH_PROJECT_LIST_SUCCESS,
  payload: message
});

export const AcquisitionSearchProjectListError = (error) => ({
  type: ACQUISITION_SEARCH_PROJECT_LIST_ERROR,
  payload: error
}); 

export const AcquisitionSearchAcquisitionTypeList = () => ({
  type: ACQUISITION_SEARCH_ACQUISITION_TYPE_LIST
});

export const AcquisitionSearchAcquisitionTypeListSuccess = (message) => ({
  type: ACQUISITION_SEARCH_ACQUISITION_TYPE_LIST_SUCCESS,
  payload: message
});

export const AcquisitionSearchAcquisitionTypeListError = (error) => ({
  type: ACQUISITION_SEARCH_ACQUISITION_TYPE_LIST_ERROR,
  payload: error
});

export const AcquisitionDetail = (data) => ({
  type: ACQUISITION_DETAIL,
  payload: data
});

export const AcquisitionDetailSuccess = (data) => ({
  type: ACQUISITION_DETAIL_SUCCESS,
  payload: data
});

export const AcquisitionDetailError = (error) => ({
  type: ACQUISITION_DETAIL_ERROR,
  payload: error
});

export const AcquisitionSearchDemandList = () => ({
  type: ACQUISITION_SEARCH_DEMAND_LIST
});

export const AcquisitionSearchDemandListSuccess = (message) => ({
  type: ACQUISITION_SEARCH_DEMAND_LIST_SUCCESS,
  payload: message
});

export const AcquisitionSearchDemandListError = (error) => ({
  type: ACQUISITION_SEARCH_DEMAND_LIST_ERROR,
  payload: error
}); 
const acquisition = (state) => state[NAME];

export const AcquisitionSelector = createStructuredSelector({
  acquisition
})
